'use strict';
require('../../../modules/es.array.filter');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'filter');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/filter.js
// module id = 558
// module chunks = 13